import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import { MemberService } from '../../../../services/member.service';
import { WidgetsService } from '../../../widgets/services/widgets.service';
import { HelpersService } from '../../../../services/helpers.service';
import { GgAuthService } from '../../../gg-gateway/services/gg-auth.service';
import { MemberModel } from '../../../../models/user.model';
import { AppGgProjectsListComponent } from '../../../gg-gateway/components/gg-projects-list/gg-projects-list.component';
import { LayoutIconService } from '../../services/lyaout-icon.service';
import { LayoutDataService } from '../../services/lyaout-data.service';

@Component({
    selector: 'app-m-layout',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    //changeDetection:ChangeDetectionStrategy.OnPush
})
export class AppLayoutComponent implements OnDestroy, OnInit {
    @Input() public integrated = false;
    subs = new Subscription()
    isMenuPanelOpened = true;
    showWidgets = false;
    currentMember: MemberModel | null = null;

    constructor(
        private layoutIconService:LayoutIconService,
        public layoutDataService:LayoutDataService,
        private memberService: MemberService,
        public widgetService: WidgetsService,
        public helper: HelpersService,
        private dialog: MatDialog,
        private ggAuthService: GgAuthService,
        public helpersService:HelpersService,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.setSubscriptions()
        this.memberService.getCurrentMember().then(member => {
            this.currentMember = member
        })
      }
    setSubscriptions() {
      this.subs.add(this.widgetService.subShowWidgets.asObservable().subscribe(res => {this.showWidgets = res}))
      this.subs.add(this.layoutDataService.bSubToggleMenuPanel.asObservable().subscribe(data=>this.isMenuPanelOpened = data))
    }
    changeProject() {
        this.dialog.open(AppGgProjectsListComponent, {
            panelClass: 'padding-modalbox',
            height: '100%',
            maxHeight: '90vh'
        })
        this.currentMember ? this.ggAuthService.loginStateSub.next({
            state: 'select_project',
            userData: this.currentMember,
            projects: this.currentMember.projects_list
        }) : null;
    }
}
